import { Alert, message } from "ant-design-vue";
import { login, getInfo, logout } from "@/api/login";
function removeInfo(commit) {
  localStorage.removeItem('AuthorizationToken');
  commit('SET_USERINFO', "");
  location.reload();
}
const user = {
  state: {
    userInfo: null,
  },
  mutations: {
    SET_USERINFO(state, userinfo) {
      state.userInfo = userinfo;
    },
  },
  actions: {
    login: ({ commit, dispatch }, form) => {
      return new Promise((resolve, reject) => {
        login(form).then(res => {
          if (res.code == 1) {
            localStorage.setItem('AuthorizationToken', res.data.AuthorizationToken);
          } else {
            message.error(res.msg)
          }
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    loginOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout().then(response => {
          if (response.code == 1) {
            removeInfo(commit)
            resolve(response)
          } else {
            removeInfo(commit)
            reject(response)
            message.error(response.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    getUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          if (response.code == 1) {
            const result = response.data
            commit('SET_USERINFO', result)
            resolve(response)
          } else {
            message.error(response.msg)
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}

export default user